import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@babackapp/ui/components/tooltip";
import { cloneElement, PropsWithChildren, ReactElement, useRef } from "react";
import useHandleKeyPress from "@/components/hot-key/use-handle-key-press.ts";

interface HotKeyProps extends PropsWithChildren {
  keyTrigger: string;
  description: string;
}

export default function HotKey(props: HotKeyProps) {
  const ref = useRef<HTMLInputElement | HTMLButtonElement>(null);

  useHandleKeyPress(props.keyTrigger, ref);

  const clonedChild = cloneElement(props.children as ReactElement, {
    ref: ref,
  });

  return (
    <Tooltip>
      <TooltipTrigger asChild>{clonedChild}</TooltipTrigger>
      <TooltipContent className="bg-white rounded-md shadow-lg p-2">
        <p className="text-sm text-muted-foreground">
          {props.description}{" "}
          <kbd className="pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium text-muted-foreground opacity-100">
            {props.keyTrigger.toUpperCase()}
          </kbd>
        </p>
      </TooltipContent>
    </Tooltip>
  );
}
